import PWDService from './apiClient';
import FieldActivityClosureStatus from './FieldActivityClosureStatus';


function ccbWorker(fieldActivity) {
    console.log("running ccbWorker for faId: ", fieldActivity.FieldActivityId);

    switch(fieldActivity.DynamicsClosureStatus) {
        case FieldActivityClosureStatus.REPAIRED:
        case FieldActivityClosureStatus.REPLACED:
        case FieldActivityClosureStatus.REMOVED:
        case FieldActivityClosureStatus.DELIVERED:
        case FieldActivityClosureStatus.CONTAINER_NOT_OUT:

            return PWDService.completeFieldActivity(fieldActivity.FieldActivityId, fieldActivity.CompletedDateTime, fieldActivity.FieldActivityRemarkValue);

        case FieldActivityClosureStatus.FOREMAN_INVESTIGATE:
            console.log("in FI case for ccbWorker, but we don't do work here");
            break;
        default:
            console.log("in default switch case of CcbWorker");
            return false;
    }
}


export { ccbWorker };